import * as React from 'react';
import { Create } from 'react-admin';
import { RegionForm,  } from './RegionForm';
import { transformMediaUrlInput } from '../../lib/media/makeUrl';

export const RegionCreate = (props: any) => {
    const transform = data => ({
    ...data,
    mediaUrl: transformMediaUrlInput(data.mediaUrl)
  });
  return (
    <Create {...props} transform={transform}>
      <RegionForm />
    </Create>
  );
}
